import { http } from "./http";
import {
  FindAllShipmentsRequest,
  FindAllShipmentsResponse,
  FindShipmentByIdResponse,
  FindShipmentQuotesRequest,
  FindShipmentQuotesResponse,
  UpdateShipmentTrackingCodeRequest,
} from "@/types/api/shipment";

export async function findAllShipments(req: FindAllShipmentsRequest): Promise<FindAllShipmentsResponse> {
  const params = new URLSearchParams({
    page: String(req.page),
    pageSize: String(req.pageSize),
    ...(req.search ? { search: req.search } : {}),
    ...(req.status ? { status: req.status } : {}),
    ...(req.startDate ? { startDate: req.startDate } : {}),
    ...(req.endDate ? { endDate: req.endDate } : {}),
  });
  return http.get<FindAllShipmentsResponse>(`/api/shipment/all?${params}`);
}

export async function findShipmentQuotes(req: FindShipmentQuotesRequest): Promise<FindShipmentQuotesResponse> {
  return http.get<FindShipmentQuotesResponse>(
    `/api/shipment/shipping-quote?quoteId=${req.quoteId}&zipCode=${req.zipCode}`,
  );
}

export async function findShipmentById(id: number): Promise<FindShipmentByIdResponse> {
  return http.get<FindShipmentByIdResponse>(`/api/shipment/${id}`);
}

export async function updateShipmentTrackingCode(
  id: number,
  req: UpdateShipmentTrackingCodeRequest,
): Promise<void> {
  return http.patch<void>(`/api/shipment/${id}/tracking-code`, req);
}
